<template>
  <v-row>
    <v-col cols="12">
      <div class="d-flex align-center justify-space-between pa-3"
           style="border-radius: 6px">
        <h3 class="kbDarkBlueText--text"
            style="font-size: 28px">
          {{ $t('general.createHtmlTemplate') }}
        </h3>

        <ButtonCopyCustomizeField />
      </div>
      <div>
        <EmailEditor ref="emailEditor" @load="editorLoaded()"/>
      </div>
      <div>
          <v-btn class="mr-2"
                 color="kbPurple"
                 outlined
                 @click="updateStep(4)">
            {{ $t('general.goBack') }}
          </v-btn>

          <v-btn :loading="loading"
                 color="kbPurple"
                 dark
                 class="float-right"
                 @click="handleEmail()">
            <span class="hidden-xs-only">
              {{ $t('general.prepareCampaign') }}
            </span>
            <v-icon dark
                    right>
              check
            </v-icon>
          </v-btn>
          <btn-custom-draft-save @template-name="templateExist"/>
        </div>
    </v-col>
  </v-row>
</template>

<script>
import { EmailEditor } from 'vue-email-editor'
import ButtonCopyCustomizeField from '@/components/widgets/EmailTemplates/ButtonCopyCustomizeField'
import BtnCustomDraftSave from '@/pages/App/Communications/CustomizeFields/BtnCustomDraftSave.vue'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import sample from '@/assets/sample.json'
import { mapGetters, mapState } from 'vuex'
import campaignsService from '@/services/campaignsService'
export default {
  components: {
    EmailEditor,
    ButtonCopyCustomizeField,
    BtnCustomDraftSave
  },
  computed: {
    ...mapGetters(['token', 'companyUuid', 'appUuid']),
    ...mapState({
      draftDesign: state => state.campaigns.selectTemplate,
      titleName: state => state.campaigns.templateName
    })
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async attachFilesToCampaign (campaignId) {
      try {
        const arrayOfPromises = this.email.attachments.map(file => {
          campaignsService.uploadFileToCampaign(
            this.token, this.companyUuid, this.appUuid, campaignId, file
          )
        })
        await Promise.all(arrayOfPromises)
      } catch (e) {
        notifications.error(e.message)
      }
    },
    async createCampaign () {
      this.loading = true
      // if campaign type is email , subject and message cannot be empty after trim
      if (rules.required(this.email.subject) !== true) {
        this.loading = false
        return notifications.error(this.$t('general.insertMessageSubject'))
      }
      if (rules.required(this.email.html) !== true) {
        this.loading = false
        return notifications.error(this.$t('general.insertMessageHtml'))
      }
      const body = { email: this.email }
      const data = {
        date: new Date().toISOString(),
        name: this.campaignName,
        ...body,
        type: this.campaignType
      }
      // verificamos si todas las personas esta seleccionado en la lista
      if (this.selectedList._id !== 'all') data.listId = this.selectedList._id
      try {
        const response = await this.$store.dispatch('createCampaign', data)
        const responseCreateList = await this.$store.dispatch('createCampaignUserList', {
          campaignId: response.campaign._id,
          createFromUser: this.selectedList._id === 'all'
        })
        await this.attachFilesToCampaign(response.campaign._id)
        this.$router.push(`/apps/${this.$store.getters.appUuid}/campaigns/${response.campaign._id}`)
        notifications.success(responseCreateList.message)
        this.loading = false
      } catch (e) {
        notifications.error(e.message)
        this.loading = false
      }
    },
    editorLoaded () {
      this.$refs.emailEditor.editor.loadDesign(sample)
    },
    handleEmail () {
      this.exportHtml()
    },
    templateExist () {
      try {
        if (this.titleName) {
          this.$store.dispatch('getTemplatesByName', this.titleName).then(response => {
            if (response.templates.count) {
              this.updateTemplate()
            } else {
              this.saveDesign()
            }
          })
        }
      } catch (e) {
        notifications.error(e.message)
      }
    },
    updateTemplate () {
      this.$refs.emailEditor.editor.saveDesign(
        async (template) => {
          try {
            const templateId = this.draftDesign._id
            await this.$store.dispatch('updateTemplate', { template, templateId })
            notifications.success(this.$t('general.templateSuccessfullyUpdated'))
          } catch (e) {
            console.error(e)
          }
        }
      )
    },
    saveDesign () {
      this.$refs.emailEditor.editor.saveDesign(
        async (template) => {
          try {
            const name = this.titleName
            await this.$store.dispatch('saveTemplate', { template, name })
            notifications.success(this.$t('general.templateSuccessfullySaved'))
          } catch (e) {
            console.error(e)
          }
        }
      )
    },
    exportHtml () {
      this.$refs.emailEditor.editor.exportHtml(
        (data) => {
          this.email.html = data.html
          this.createCampaign()
        }
      )
    },
    updateStep (step) {
      this.$emit('updateStep', step)
    }
  },
  watch: {
    async draftDesign (value) {
      if (value) {
        try {
          const response = await this.$store.dispatch('getTemplateById', this.draftDesign._id)
          this.$refs.emailEditor.editor.loadDesign(response.template.template)
        } catch (e) {
          console.error(e.message)
        }
      } else {
        this.editorLoaded()
      }
    }
  },
  props: {
    campaignName: {
      type: String,
      default: ''
    },
    campaignType: {
      type: String,
      required: true
    },
    email: {
      type: Object,
      required: true
    },
    selectedList: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
  ::v-deep iframe {
    height: 80vh!important;
  }

  @media only screen and (min-width: 1264px) {
    ::v-deep iframe {
      height: 500px!important;
    }
  }

  @media only screen and (min-width: 1904px) {
    ::v-deep iframe {
      height: 65vh!important;
    }
  }
</style>
